import {createRouter, createWebHistory} from 'vue-router';
import PasswordResetDoneView from '../apps/auth/PasswordResetDoneView.vue';
import PasswordResetFromKeyDoneView from '../apps/auth/PasswordResetFromKeyDoneView.vue';
import PasswordResetFromKeyView from '../apps/auth/PasswordResetFromKeyView.vue';
import PasswordResetRequestView from '../apps/auth/PasswordResetRequestView.vue';
import SigninView from '../apps/auth/SigninView.vue';
import SignoutView from '../apps/auth/SignoutView.vue';
import TwoFactorView from '../apps/auth/TwoFactorView.vue';

const AUTH_BASE = '/accounts/';

export default function createAuthRouter() {
  return createRouter({
    history: createWebHistory(AUTH_BASE),
    routes: [
      {path: '/signin/', name: 'signin', component: SigninView},
      {path: '/2fa/', name: 'two_factor', component: TwoFactorView},
      {path: '/signout/', name: 'signout', component: SignoutView},
      {path: '/password/reset/', name: 'password_reset', component: PasswordResetRequestView},
      {path: '/password/reset/done/', name: 'password_reset_done', component: PasswordResetDoneView},
      {
        path: '/password/reset/key/:key/',
        name: 'password_reset_from_key',
        component: PasswordResetFromKeyView,
      },
      {
        path: '/password/reset/key/done/',
        name: 'password_reset_from_key_done',
        component: PasswordResetFromKeyDoneView,
      },
    ],
  });
}
